import type { ReactNode } from "react";

export function ResultLabel({ children }: { children: ReactNode }) {
  return (
    <div className="mb-1.5 text-[10px] font-bold tracking-[0.12em] text-stone-400 uppercase">
      {children}
    </div>
  );
}
